module.exports = __webpack_public_path__ + "assets/protection.c412cf3c.svg";